import request from '@/utils/request'

let AnswerApi = {

  /*vip常见问题列表*/
  list(data) {
    return request._post('/shop/plus.answer.Index/index', data);
},
/*添加vip常见问题*/
add(data) {
    return request._post('/shop/plus.answer.Index/add', data);
},
/*修改vip常见问题*/
edit(data) {
    return request._post('/shop/plus.answer.Index/edit', data);
},
/*删除vip常见问题*/
del(data) {
    return request._post('/shop/plus.answer.Index/del', data);
},
/*vip常见问题详情*/
detail(data) {
  return request._post('/shop/plus.answer.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.answer.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.answer.Setting/getSetting', data, errorback);
    },
}
export default AnswerApi;



// WEBPACK FOOTER //
// ./src/api/answer.js